import { Link } from "react-router-dom";
import type { ClubFull } from "@/lib/types";

interface HeroProps {
  club: ClubFull | null;
}

export default function Hero({ club }: HeroProps) {
  const district = club?.district || "국제로타리 3680지구";
  const clubName = club?.club_name || "대전민들레로타리클럽";
  const foundYear = club?.found_year ? String(club.found_year) : "";

  const memberCnt = club?.stats?.member;
  const years = club?.stats?.years;
  const hasMember = memberCnt != null && String(memberCnt) !== "";
  const hasYears = years != null && String(years) !== "";
  const summaryParts: string[] = [];
  if (hasMember) summaryParts.push(`재적회원 ${memberCnt}명`);
  if (hasYears) summaryParts.push(`창립 ${years}주년`);

  return (
    <section className="relative w-full overflow-hidden">
      {/* 배경 이미지 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dreamy%20dandelion%20field%20at%20golden%20hour%20with%20soft%20warm%20sunlight%2C%20floating%20dandelion%20seeds%20drifting%20in%20the%20gentle%20breeze%2C%20artistic%20stylized%20illustration%2C%20soft%20pastel%20yellow%20and%20warm%20cream%20tones%2C%20shallow%20depth%20of%20field%20bokeh%2C%20serene%20hopeful%20community%20atmosphere%2C%20clean%20minimal%20composition%2C%20gentle%20golden%20glow%2C%20high%20detail%2C%20harmonious%20warm%20color%20palette&width=1600&height=900&seq=hero-dandelion-01&orientation=landscape"
          alt="햇살 아래 피어난 민들레 들판"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/50 via-primary-950/30 to-primary-950/60"></div>
      </div>

      {/* 콘텐츠 */}
      <div className="relative z-10 flex min-h-[420px] md:min-h-[560px] w-full flex-col items-center justify-center px-4 md:px-6 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
          <i className="ri-seedling-line" aria-hidden="true"></i>
          {clubName}
        </span>
        <h1 className="mt-6 max-w-3xl font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
          봉사의 씨앗을
          <br className="sm:hidden" />
          <span className="text-secondary-300"> 멀리 퍼뜨립니다</span>
        </h1>

        <p className="mt-4 text-sm md:text-base font-medium tracking-wide text-background-100/90">
          {district}
          {foundYear && <span className="text-secondary-200"> · Since {foundYear}</span>}
        </p>

        {summaryParts.length > 0 && (
          <p className="mt-2 inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm md:text-base font-semibold text-background-50">
            {summaryParts.map((part, i) => (
              <span key={part} className="inline-flex items-center gap-3">
                {i > 0 && (
                  <span className="text-background-50/40" aria-hidden="true">
                    |
                  </span>
                )}
                {part}
              </span>
            ))}
          </p>
        )}

        <p className="mt-5 max-w-xl text-base md:text-lg text-background-100/90 leading-relaxed">
          대전 지역의 전문가들이 모여 봉사와 나눔, 그리고 회원 간 비즈니스 연결을
          실천하는 로타리클럽입니다.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/bizmap"
            className="w-full sm:w-auto whitespace-nowrap rounded-full bg-secondary-500 px-7 py-3.5 text-sm font-semibold text-primary-950 hover:bg-secondary-600 transition-colors"
          >
            <i className="ri-map-pin-line mr-2" aria-hidden="true"></i>
            민들레 비즈맵
          </Link>
          <Link
            to="/about/greeting"
            className="w-full sm:w-auto whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3.5 text-sm font-semibold text-background-50 hover:bg-background-50/20 transition-colors"
          >
            클럽소개
          </Link>
        </div>
      </div>
    </section>
  );
}